import type { TransactionWithCategory } from "@/types";

function normalizedName(value: string | null | undefined): string {
  return (value ?? "").trim().toLowerCase();
}

export function isUncategorizedCategoryName(name: string | null | undefined): boolean {
  return normalizedName(name) === "uncategorized";
}

export function isUncategorizedTransaction(tx: TransactionWithCategory): boolean {
  return (
    tx.categoryId == null ||
    tx.category == null ||
    tx.classifiedBy === "uncategorized" ||
    isUncategorizedCategoryName(tx.category?.name)
  );
}
